import { IOpsLiveTask, IOpsTaskExtras } from 'types/operationsControl.interface'

const shiftTime = (base: string, addMin: number): string => {
  const m = base.match(/(\d{1,2}):(\d{2})/)
  if (!m) return base
  const total = Number(m[1]) * 60 + Number(m[2]) + addMin
  const h = Math.floor(total / 60) % 24
  const min = total % 60
  return `${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}`
}

export const buildTaskExtras = (t: IOpsLiveTask): IOpsTaskExtras => {
  const history = [
    {
      id: 1,
      at: t.generatedAt,
      actor: t.sourceName ? `${t.sourceName} (scheduler)` : 'Supervisor',
      action: 'Task generated',
      fromState: null,
      toState: 'Not started',
      note: null,
    },
  ]
  let nextId = 2
  if (t.operator) {
    history.push({
      id: nextId++,
      at: t.generatedAt,
      actor: 'Resolver Engine',
      action: 'Assigned',
      fromState: null,
      toState: null,
      note: `${t.operator}${t.machine ? ` · ${t.machine}` : ''}`,
    })
  }
  if (t.taskStatus >= 1 && t.taskStatus !== 0) {
    history.push({
      id: nextId++,
      at: shiftTime(t.generatedAt, 6),
      actor: t.operator || 'System',
      action: 'Started',
      fromState: 'Not started',
      toState: 'In progress',
      note: null,
    })
  }
  if (t.taskStatus === 3) {
    history.push({
      id: nextId++,
      at: shiftTime(t.generatedAt, 44),
      actor: t.operator || 'System',
      action: 'Completed',
      fromState: 'In progress',
      toState: 'Completed',
      note: null,
    })
  }
  if (t.taskStatus === 4) {
    history.push({
      id: nextId++,
      at: t.generatedAt,
      actor: t.operator || 'System',
      action: 'Reported issue',
      fromState: 'In progress',
      toState: 'Reported — needs review',
      note: t.blockedReason,
    })
  }
  return {
    componentValues: [],
    resolverNote: t.operator
      ? `Resolver matched ${t.operator} by capability and availability`
      : t.unassignedReason || 'Awaiting resolver pass',
    overrideNote: null,
    history,
  }
}
